import { useState } from 'react'
import { OVERLAY_TYPE_READ_ONLY } from '../ItemCard.constants'
import { Overlay } from '../ItemCard.styles'
import { ItemCardOverlayProps } from '../ItemCard.types'
import Button from '../../Button'
import Dialog from '../../Dialog'

const ItemCardOverlay = ({
  overlayType,
  outOfStockAction,
  item
}: ItemCardOverlayProps) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  const handleOpenDialog = () => setOpenDialog(!openDialog)

  const handleConfirmation = () => {
    if (outOfStockAction?.requestConfirmation) {
      handleOpenDialog()
    } else {
      outOfStockAction?.onClick({ item })
    }
  }

  const onConfirmDialog = () => {
    outOfStockAction?.onClick({ item })
    handleOpenDialog()
  }

  return (
    <Overlay
      className={`overlay ${overlayType}`}
      data-testid={`overlay${overlayType}`}>
      {overlayType !== OVERLAY_TYPE_READ_ONLY &&
        outOfStockAction &&
        outOfStockAction.display && (
          <>
            <Button
              data-testid="overlayButton"
              className="button-overlay"
              onClick={handleConfirmation}
              size="small"
              {...outOfStockAction.button}
            />
            {outOfStockAction?.requestConfirmation && (
              <Dialog
                data-testid="overlayDialog"
                open={openDialog}
                closeActions={() => setOpenDialog(false)}
                buttons={[
                  {
                    label: outOfStockAction.dialog?.confirmText || 'Confirm',
                    fullWidth: true,
                    actions: () => onConfirmDialog()
                  },
                  {
                    label: outOfStockAction.dialog?.cancelText || 'Cancel',
                    color: 'inherit',
                    variant: 'outlined',
                    actions: () => setOpenDialog(false)
                  }
                ]}
                {...outOfStockAction.dialog}
              />
            )}
          </>
        )}
    </Overlay>
  )
}

export default ItemCardOverlay
